import { inject, Injectable, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { BRANDING } from '../branding';

export interface PageMeta {
  title: string;
  section: string;
}

/** Sets "<Page> · <app name>" as the document title and exposes the page title/section to the header. */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  readonly page = signal<PageMeta>({ title: '', section: '' });

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot) ?? '';
    let route = snapshot.root;
    while (route.firstChild) route = route.firstChild;
    this.page.set({ title, section: route.data['section'] ?? '' });
    this.title.setTitle(title ? `${title} · ${BRANDING.appName}` : BRANDING.appName);
  }
}
